define("settings/templates/application", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--page">
    <NavigationSidebar />
  
    <div class="o--page__push"></div>
  
    <main class="o--page__content tAC--content">
      <Shared::TrialCountdown @route="overview" />
  
      <div class="o--container tAC--container">
        {{outlet}}
      </div>
    </main>
  </div>
  */
  {
    "id": "DHZV2nGC",
    "block": "[[[10,0],[14,0,\"o--page\"],[12],[1,\"\\n  \"],[8,[39,0],null,null,null],[1,\"\\n\\n  \"],[10,0],[14,0,\"o--page__push\"],[12],[13],[1,\"\\n\\n  \"],[10,\"main\"],[14,0,\"o--page__content tAC--content\"],[12],[1,\"\\n    \"],[8,[39,1],null,[[\"@route\"],[\"overview\"]],null],[1,\"\\n\\n    \"],[10,0],[14,0,\"o--container tAC--container\"],[12],[1,\"\\n      \"],[46,[28,[37,3],null,null],null,null,null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"navigation-sidebar\",\"shared/trial-countdown\",\"component\",\"-outlet\"]]",
    "moduleName": "settings/templates/application.hbs",
    "isStrictMode": false
  });
});